/** @jsx jsx */
import { jsx } from "theme-ui";
import { graphql, HeadFC, PageProps } from "gatsby";
import DefaultLayout from "../layouts/DefaultLayout";
import Seo from "../components/Seo";
import HeroSection from "../components/HeroSection";
import { getImage } from "gatsby-plugin-image";
import TextSection from "../components/TextSection";

function IndexPage({ data }: PageProps<Queries.HomeQueryQuery>) {
	// Desktop hero image
	const desktopHero = getImage(
		data.allFile?.edges?.find(
			(n: { node: { relativePath: string } }) =>
				n?.node?.relativePath === "first-virginia-loans.png"
		)?.node?.childImageSharp?.gatsbyImageData || {}
	);
	// Mobile hero image
	const mobileHero = getImage(
		data.allFile?.edges?.find(
			(n: { node: { relativePath: string } }) =>
				n?.node?.relativePath === "first-virginia-loans-mobile.png"
		)?.node?.childImageSharp?.gatsbyImageData || {}
	);
	// Page render
	return (
		<DefaultLayout>
			<HeroSection
				headline="We Put Customers First"
				preHeadline="Real cash solutions"
				backgroundColor="chrome"
				buttonText="Take The First Step"
				buttonLink="https://www.google.com/maps/search/?api=1&query=36.85667059967011%2C-76.20202207151335&query_place_id=ChIJC6NlHUKWuokRe2iY874ih8A"
				fullSizeImage={true}
				mobileImage={mobileHero}
				desktopImage={desktopHero}
				mobileImageAlt="Get started with First Virginia Loans"
				desktopImageAlt="First Virgnia Loans"
			/>
			<TextSection
				text="The First Virginia Team of Experts is available to help you access cash when life throws a hurdle in your path. Pop by one of our conveniently located stores to discuss third party lending products, our Check Cashing Services or to pick up a Green Dot® Visa® Debit Card. Exceptional customer service is our priority, and we’ll walk you through the process from application to approval."
				textColor="white"
				backgroundColor="forestGreen"
			/>
		</DefaultLayout>
	);
}

export default IndexPage;

// Query for images
export const query = graphql`
	query HomeQuery {
		allFile {
			edges {
				node {
					id
					relativePath
					childImageSharp {
						gatsbyImageData(
							placeholder: DOMINANT_COLOR
						)
					}
				}
			}
		}
	}
`;

// Page metadata
export const Head: HeadFC = () => (
	<Seo
		title="Short-Term Cash Solutions In-Store –First VirginiaFinancial Services"
		description="First Virginia Financial Servicessoffers Third Party Lending Products,Check Cashing, Green Dot® Visa® Debit Cards, along with expert customer care to help you accomplish your financial goals."
	/>
);
